import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

export type CPTableDataViewToggleLoc =
	| 'CPTableDataViewToggleGridTooltip'
	| 'CPTableDataViewToggleTableTooltip';

export const cpTableDataViewToggleLocs: LocDefs<CPTableDataViewToggleLoc> = {
	CPTableDataViewToggleGridTooltip: {
		defaultValue: 'View as a grid',
		description: 'Assistive text displayed on the view as grid button',
		displayPath: 'Data View|Toggle to Grid',
		displayType: 'Content',
		shared: true,
		portal: 'CP',
		feature: HubFeature.CandidateAccess,
	},
	CPTableDataViewToggleTableTooltip: {
		defaultValue: 'View as a table',
		description: 'Assistive text displayed on the view as table button',
		displayPath: 'Data View|Toggle to Table',
		displayType: 'Content',
		shared: true,
		portal: 'CP',
		feature: HubFeature.CandidateAccess,
	},
};

export const LOC_KEYS = MapLocKeys<CPTableDataViewToggleLoc>(cpTableDataViewToggleLocs);
export type CPTableDataViewToggleLocType = LocMap<CPTableDataViewToggleLoc>;
